(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22778],{

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 22778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SideEffects; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
;// CONCATENATED MODULE: ./src/components/tylenolautism/sideEffects/icons/PoorEye.tsx


function PoorEye() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "65",
        height: "65",
        fill: "none",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_138",
                style: {
                    maskType: "alpha"
                },
                width: "65",
                height: "65",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H65V65H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#901316",
                mask: "url(#mask0_1_138)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M32.906 50.953c-16.682 0-30.516-15.97-30.516-18.818 0-2.848 13.834-18.819 30.516-18.819 16.479 0 30.516 16.784 30.516 18.819 0 2.746-14.24 18.818-30.516 18.818zM4.425 32.135c.61 2.34 13.122 16.784 28.481 16.784 15.157 0 27.363-14.343 28.482-16.784-1.22-2.543-13.53-16.784-28.482-16.784-15.156 0-27.77 14.342-28.481 16.784z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M32.906 46.884c-11.189 0-20.344-9.155-20.344-20.344a19.9 19.9 0 011.119-6.51l1.933.61a19.327 19.327 0 00-.916 5.9c0 10.07 8.24 18.31 18.31 18.31 10.07 0 18.31-8.24 18.31-18.31 0-1.933-.306-3.967-.916-5.798l1.933-.61c.712 2.035 1.017 4.272 1.017 6.409-.102 11.189-9.256 20.343-20.446 20.343z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M32.906 33.66a7.076 7.076 0 01-7.12-7.12c0-.814.101-1.526.407-2.237 1.017-2.849 3.662-4.883 6.713-4.883 3.052 0 5.798 1.933 6.714 4.883.203.712.407 1.525.407 2.237a7.076 7.076 0 01-7.12 7.12zm0-12.206c-2.136 0-4.17 1.424-4.78 3.459a4.613 4.613 0 00-.306 1.627c0 2.849 2.238 5.086 5.086 5.086 2.849 0 5.086-2.237 5.086-5.086 0-.508-.101-1.119-.305-1.627-.61-2.035-2.543-3.459-4.78-3.459zM3.134 21.268l5.107 5.107-1.438 1.439-5.107-5.108 1.438-1.438zM10.255 14.148l5.107 5.107-1.439 1.438-5.107-5.107 1.438-1.438zM21.598 7.242l4.087 7.154-1.766 1.01-4.088-7.154 1.767-1.01zM62.677 21.268l1.438 1.438-5.107 5.108-1.438-1.439 5.107-5.107zM55.556 14.148l1.439 1.438-5.107 5.107-1.439-1.438 5.108-5.107zM44.212 7.242l1.766 1.01-4.087 7.153-1.767-1.01 4.088-7.153zM31.889 5.688h2.034v8.137H31.89V5.688zM6.732 36.526l1.438 1.439-5.107 5.107-1.438-1.439 5.107-5.107zM13.852 43.647l1.439 1.438-5.107 5.107-1.439-1.438 5.107-5.107zM23.87 48.946l1.767 1.01-4.088 7.153-1.766-1.01 4.088-7.153zM59.08 36.526l5.108 5.107-1.439 1.439-5.107-5.107 1.438-1.439zM51.96 43.647l5.107 5.107-1.438 1.438-5.107-5.107 1.438-1.438zM41.943 48.946l4.088 7.154-1.767 1.009-4.087-7.153 1.766-1.01zM31.889 50.444h2.034v8.138H31.89v-8.138z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M31.28 5.078h3.253v7.682c1.815.117 3.594.424 5.321.88l4.131-7.229 2.825 1.614-3.79 6.63c2.647.998 5.138 2.307 7.412 3.756l5.124-5.125 2.3 2.3-4.697 4.698a52.31 52.31 0 015.224 4.416l4.294-4.294 2.3 2.3-4.331 4.332c.28.31.544.613.79.905.8.944 1.43 1.788 1.865 2.472.217.34.392.652.514.92.113.249.217.534.217.8 0 .286-.089.595-.208.892-.124.307-.302.65-.523 1.018-.442.738-1.083 1.618-1.891 2.58-.201.24-.413.485-.635.734l4.274 4.274-2.3 2.3-4.233-4.232a49.533 49.533 0 01-5.25 4.39l4.663 4.663-2.3 2.3-5.111-5.11c-2.294 1.433-4.807 2.723-7.471 3.705l3.815 6.678-2.824 1.613-4.168-7.294c-1.736.448-3.52.75-5.337.865v7.68H31.28v-7.678c-1.83-.11-3.62-.4-5.355-.834l-4.149 7.261-2.824-1.613 3.782-6.62c-2.696-.97-5.225-2.25-7.525-3.678l-5.025 5.025-2.3-2.3 4.574-4.575a47.75 47.75 0 01-5.237-4.403l-4.158 4.157-2.3-2.3 4.217-4.216a32.65 32.65 0 01-.639-.754c-.793-.966-1.42-1.85-1.851-2.596a7.47 7.47 0 01-.51-1.032c-.116-.303-.2-.614-.2-.9 0-.287.084-.597.2-.9.121-.312.294-.66.51-1.032.432-.746 1.058-1.63 1.851-2.597.202-.246.415-.497.639-.754L.834 22.706l2.3-2.3 4.087 4.087a47.365 47.365 0 015.237-4.403l-4.504-4.504 2.3-2.3 4.955 4.955c2.3-1.428 4.83-2.71 7.527-3.679L19 8.025l2.825-1.614 4.102 7.18a29.342 29.342 0 015.353-.835V5.078zm2.034 7.632a25.174 25.174 0 00-.816 0V6.297h.816v6.413zm-2.034 1.267a28.14 28.14 0 00-5.001.782l-2.587 1.477-.342-.599c-2.585.91-5.023 2.124-7.255 3.49l.128.128-.713.713.544.172c4.745-2.998 10.572-5.398 16.852-5.398 6.325 0 12.158 2.481 16.899 5.55l.623-.197-.667-.667c-2.265-1.442-4.737-2.732-7.353-3.7l-.29.508-2.401-1.371a26.788 26.788 0 00-5.184-.884v.454H31.28v-.458zm18.851 7.997c-4.79-3.289-10.772-6.014-17.225-6.014-6.312 0-12.203 2.554-16.955 5.698a18.616 18.616 0 00-.643 4.882c0 9.734 7.966 17.7 17.7 17.7 9.734 0 17.7-7.966 17.7-17.7 0-1.512-.193-3.087-.577-4.566zm-35.67.715a19.849 19.849 0 00-.372 3.851c0 10.407 8.512 18.92 18.919 18.92s18.919-8.513 18.919-18.92c0-1.152-.105-2.34-.316-3.505a48.513 48.513 0 01.95.73c.124.924.181 1.857.182 2.773-.1 10.8-8.893 19.645-19.667 19.737h-.17c-10.852 0-19.734-8.882-19.734-19.735 0-1.035.09-2.07.259-3.085a41.034 41.034 0 011.03-.766zm.28-1.686l-.202-.063-.616.615-.06-.06c-.015.05-.028.101-.042.153.3-.217.607-.432.92-.645zm-2.427 1.775c.082-.431.178-.858.286-1.278a46.52 46.52 0 00-4.517 3.855l.583.583a47.61 47.61 0 013.648-3.16zm-4.935 3.597l-.157-.157c-.193.199-.38.396-.562.59l.143.144.576-.577zm-1.535 1.341l.563.564a24.956 24.956 0 00-1.673 2.08c-.445.63-.775 1.193-.894 1.604l-.048.162.043.163c.106.407.427.967.858 1.587.423.607.994 1.332 1.697 2.13l-.547.547a31.069 31.069 0 01-.56-.663c-.764-.932-1.349-1.762-1.739-2.434a6.273 6.273 0 01-.426-.86c-.094-.243-.119-.392-.119-.461 0-.07.025-.218.12-.462.09-.235.23-.522.425-.86.39-.672.975-1.502 1.74-2.433.177-.217.364-.438.56-.664zm-.047 10.607l-3.31 3.31.576.577 3.297-3.296c-.193-.199-.38-.396-.563-.591zm1.424-.271c-.193-.2-.38-.396-.561-.591l.072-.073.577.577-.088.087zm.862.862a46.137 46.137 0 005.248 4.392l.521-.521 2.3 2.3-.057.058c2.231 1.365 4.669 2.578 7.254 3.489l.295-.517 2.29 1.308c1.733.451 3.52.755 5.346.87v-.458h3.253v.454c1.865-.123 3.7-.453 5.484-.944l2.153-1.23.264.46c2.605-.942 5.074-2.196 7.34-3.604l2.186-2.186.432.432a48.485 48.485 0 005.262-4.378l-.596-.596a49.14 49.14 0 01-4.277 3.683c-5.139 3.932-12.108 7.602-19.875 7.602-7.866 0-14.962-3.694-20.14-7.639a46.962 46.962 0 01-4.123-3.535l-.56.56zM59.316 35.9l.596.596c.197-.223.385-.44.564-.654.781-.93 1.38-1.757 1.78-2.423.2-.334.345-.618.437-.848.097-.24.12-.38.12-.436v-.003c-.005-.019-.023-.108-.107-.291a6.594 6.594 0 00-.433-.772c-.397-.623-.992-1.424-1.767-2.34a37.07 37.07 0 00-.723-.828l-.484.483c1.384 1.539 2.316 2.815 2.638 3.487l.124.258-.119.26c-.303.662-1.234 1.953-2.626 3.511zm-2.28-9.852l.485-.486a51.074 51.074 0 00-4.014-3.484c.073.343.137.688.191 1.034 1.231.99 2.35 1.985 3.337 2.936zm-3.137-1.19c.042.565.062 1.128.062 1.683v.006c-.104 11.52-9.528 20.947-21.055 20.947h-.658l.001-.01c-11.225-.35-20.296-9.638-20.296-20.944 0-.665.035-1.33.102-1.99a43.562 43.562 0 00-4.558 4.34 24.556 24.556 0 00-1.768 2.175c-.343.484-.553.846-.656 1.076.094.216.29.564.62 1.039.414.594.997 1.331 1.734 2.16 1.474 1.654 3.547 3.652 6.077 5.58 5.07 3.861 11.909 7.39 19.402 7.39 7.39 0 14.102-3.501 19.135-7.352a47.166 47.166 0 006.106-5.581c1.323-1.452 2.185-2.614 2.55-3.238-.384-.645-1.272-1.824-2.62-3.287a47.307 47.307 0 00-4.178-3.994zm-1.662-2.876c-.342-.254-.691-.506-1.047-.756a11.9 11.9 0 00-.025-.085l.234-.074.489.488.192-.192c.056.205.108.411.157.619zm-.095-2.428l.034-.01 3.957-3.958-.577-.577-4.083 4.084c.225.153.449.306.67.46zm7.675 6.59l3.437-3.438-.577-.576-3.428 3.428c.195.197.384.392.568.585zm-.737 11.244l-.576.577.017.017c.195-.197.384-.393.567-.587l-.008-.007zm.87.87c-.184.193-.372.389-.567.586l3.366 3.366.577-.577-3.376-3.375zm-46.481 6.634l-3.862 3.862.577.576 3.974-3.974a45.727 45.727 0 01-.69-.464zM5.798 25.946c.181-.195.369-.392.562-.59L3.134 22.13l-.577.576 3.24 3.24zm7.724-6.605c.21-.144.422-.286.636-.428l-3.903-3.904-.577.577L13.39 19.3l.131.042zm11.19-5.422L21.37 8.074l-.708.404 3.248 5.686c.265-.085.532-.167.8-.245zm-.802 36.187l-3.296 5.767.709.405 3.387-5.928c-.268-.078-.535-.16-.8-.244zm8.588 1.453v6.414h.816v-6.414a25.185 25.185 0 01-.816 0zm8.582-1.251l3.411 5.97.709-.405-3.324-5.816c-.264.087-.53.17-.796.25zm10.487-5.04l4.062 4.062.576-.576-3.95-3.95c-.227.156-.456.31-.688.464zM41.855 14.24l3.292-5.762-.709-.404-3.377 5.91c.266.082.53.168.794.256zm-8.949 5.79c-2.772 0-5.201 1.85-6.14 4.478l-.006.018-.007.017c-.263.613-.358 1.237-.358 1.997 0 3.63 2.88 6.511 6.511 6.511 3.63 0 6.511-2.88 6.511-6.51 0-.616-.179-1.353-.381-2.064-.836-2.681-3.337-4.448-6.13-4.448zm-7.28 4.05c1.1-3.06 3.955-5.27 7.28-5.27 3.308 0 6.298 2.097 7.296 5.312l.002.007.002.006c.202.71.43 1.599.43 2.405a7.686 7.686 0 01-7.73 7.73 7.686 7.686 0 01-7.73-7.73c0-.862.108-1.656.45-2.46zm1.924.632c.702-2.295 2.978-3.867 5.356-3.867 2.486 0 4.658 1.578 5.357 3.867.229.583.339 1.26.339 1.828 0 3.185-2.51 5.696-5.696 5.696-3.185 0-5.695-2.51-5.695-5.696 0-.57.11-1.246.339-1.828zm5.356-2.648c-1.885 0-3.669 1.264-4.197 3.024l-.007.026-.01.025c-.172.43-.262.962-.262 1.401 0 2.512 1.964 4.477 4.476 4.477s4.477-1.965 4.477-4.477c0-.44-.09-.972-.262-1.4l-.01-.026-.008-.026c-.53-1.766-2.217-3.024-4.197-3.024z",
                        clipRule: "evenodd"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var icons_PoorEye = (PoorEye);

;// CONCATENATED MODULE: ./src/components/tylenolautism/sideEffects/icons/HigherInterest.tsx


function HigherInterest() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "65",
        height: "65",
        fill: "none",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_145",
                style: {
                    maskType: "alpha"
                },
                width: "65",
                height: "65",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H65V65H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#901316",
                mask: "url(#mask0_1_145)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M43.685 48.017c-1.85 0-5.567-.074-7.662-.276a1.79 1.79 0 11.34-3.563c1.868.176 5.407.259 7.322.259 10.126 0 17.08-2.109 17.689-5.298L43.685 11.773 35.687 24.14a1.796 1.796 0 01-2.478.532 1.794 1.794 0 01-.532-2.477L42.18 7.499a1.793 1.793 0 013.01 0l19.523 30.203c.188.289.287.628.287.973.003 5.936-7.766 9.343-21.315 9.343v-.001z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.39 30.656c-8.736 0-17.58-2.654-17.58-7.729 0-10.148 35.165-10.148 35.165 0-.002 5.075-8.847 7.729-17.584 7.729zm0-11.874c-8.684 0-14.001 2.685-14.001 4.145 0 1.461 5.317 4.146 14.002 4.146s14.002-2.685 14.002-4.146c0-1.46-5.317-4.145-14.002-4.145zM18.39 58.316c-8.736 0-17.58-2.654-17.58-7.728 0-10.148 35.165-10.148 35.165 0-.002 5.074-8.847 7.728-17.584 7.728zm0-11.874c-8.684 0-14.001 2.685-14.001 4.146 0 1.46 5.317 4.145 14.002 4.145s14.002-2.684 14.002-4.145c0-1.461-5.317-4.146-14.002-4.146z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M34.181 52.38c-.99 0-1.791-.803-1.791-1.793v-27.66a1.792 1.792 0 013.583 0v27.66c0 .99-.803 1.792-1.792 1.792zM2.599 52.38c-.99 0-1.792-.803-1.792-1.793v-27.66a1.792 1.792 0 013.584 0v27.66c0 .99-.803 1.792-1.792 1.792zM28.929 42.29c-.99 0-1.792-.803-1.792-1.792v-7.483a1.792 1.792 0 013.584 0v7.483c-.001.99-.803 1.791-1.792 1.791z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var icons_HigherInterest = (HigherInterest);

;// CONCATENATED MODULE: ./src/components/tylenolautism/sideEffects/icons/EarlyUse.tsx


function EarlyUse() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "65",
        height: "65",
        fill: "none",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_154",
                style: {
                    maskType: "alpha"
                },
                width: "65",
                height: "65",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H65V65H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#901316",
                fillRule: "evenodd",
                clipRule: "evenodd",
                mask: "url(#mask0_1_154)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.802 25.554a6.805 6.805 0 016.803 6.803 6.805 6.805 0 01-6.803 6.802A6.805 6.805 0 010 32.357a6.805 6.805 0 016.802-6.803zm0 4.535a2.268 2.268 0 10.002 4.537 2.268 2.268 0 00-.002-4.537zM58.198 25.554A6.805 6.805 0 0165 32.357a6.805 6.805 0 01-6.802 6.802 6.805 6.805 0 01-6.803-6.802 6.805 6.805 0 016.803-6.803zm0 4.535a2.268 2.268 0 10.001 4.537 2.268 2.268 0 00-.001-4.537z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M53.663 30.09a2.268 2.268 0 010 4.534H52.64l-1.264 10.107a2.27 2.27 0 01-2.113 1.984A2.274 2.274 0 0146.927 45l-3.846-15.39-3.845 15.39a2.27 2.27 0 01-4.402 0l-3.846-15.39-3.846 15.39a2.27 2.27 0 01-4.402 0l-3.846-15.39-.822 3.296a2.27 2.27 0 01-2.201 1.718h-4.535a2.268 2.268 0 010-4.535h2.763l2.594-10.376a2.27 2.27 0 014.402 0l3.846 15.389 3.846-15.39a2.27 2.27 0 014.402 0l3.846 15.39 3.845-15.39a2.27 2.27 0 014.403 0l3.102 12.412.006-.049a2.268 2.268 0 012.249-1.986h3.023z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var icons_EarlyUse = (EarlyUse);

;// CONCATENATED MODULE: ./src/components/tylenolautism/sideEffects/icons/RarelyRespond.tsx


function RarelyRespond() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "65",
        height: "65",
        fill: "none",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_141",
                style: {
                    maskType: "alpha"
                },
                width: "65",
                height: "65",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H65V65H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_1_141)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#901316",
                    d: "M58.5 7.363a4.96 4.96 0 00-2.108-4.055 5.023 5.023 0 00-4.554-.564l-18.326 6.9h-13.66a4.941 4.941 0 00-3.47 1.453 4.962 4.962 0 00-1.45 3.476v.704H11.42a4.943 4.943 0 00-3.47 1.452A4.963 4.963 0 006.5 20.207v11.265a4.962 4.962 0 001.449 3.477 4.94 4.94 0 003.47 1.452h3.513v.704a4.963 4.963 0 001.45 3.477 4.943 4.943 0 003.47 1.452h.983l2.052 14.337a6.282 6.282 0 002.094 3.84 6.26 6.26 0 004.09 1.539 6.264 6.264 0 004.765-2.156 6.291 6.291 0 001.475-5.026l-1.799-12.533 18.326 6.9c.55.203 1.13.308 1.715.31 1.012-.002 2-.306 2.839-.873a4.962 4.962 0 002.108-4.056V7.363zM11.418 32.177a.703.703 0 01-.703-.704V20.207c0-.389.315-.704.703-.704h3.513v12.674h-3.513zm7.73 4.929V14.574c0-.39.314-.704.702-.704h11.946v23.94H19.85a.704.704 0 01-.702-.705v.001zm11.524 19.715c-.4.449-.973.705-1.574.704a2.057 2.057 0 01-2.024-1.774l-1.967-13.716h4.188l1.799 13.152a2.034 2.034 0 01-.422 1.634zm23.611-12.505a.677.677 0 01-.309.563.673.673 0 01-.647 0l-17.314-6.506V13.025l17.314-6.506a.675.675 0 01.647 0 .678.678 0 01.31.563v37.234z"
                })
            })
        ]
    });
}
/* harmony default export */ var icons_RarelyRespond = (RarelyRespond);

;// CONCATENATED MODULE: ./src/components/tylenolautism/sideEffects/icons/Sensitivity.tsx


function Sensitivity() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "65",
        height: "65",
        fill: "none",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_160",
                style: {
                    maskType: "alpha"
                },
                width: "65",
                height: "65",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H65V65H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#901316",
                mask: "url(#mask0_1_160)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.933 33.889c-1.601 1.473-3.97 3.778-2.945 8.003l.064.192c.96 2.497 3.073 3.97 5.57 3.97.64 0 1.345-.064 1.985-.32 4.098-1.217 7.748-5.763 6.531-11.909l-3.137.64c.832 4.29-1.537 7.428-4.29 8.196-.832.256-2.753.512-3.65-1.6-.512-2.242.449-3.33 2.049-4.803 1.408-1.345 3.585-3.393 1.857-6.658-.896-1.729-1.729-2.818-2.305-3.586-.704-.96-.96-1.345-1.088-1.985.064-4.225 3.522-7.619 7.747-7.619a7.733 7.733 0 017.748 7.747 7.839 7.839 0 01-2.754 5.955l2.05 2.433c2.496-2.113 3.905-5.122 3.905-8.388 0-6.018-4.93-10.948-10.949-10.948-6.018 0-10.948 4.93-10.948 10.948v.192c.192 1.537.896 2.497 1.728 3.586.576.768 1.28 1.728 2.05 3.201.51.96.383 1.28-1.218 2.753z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22.256 4.053c-6.21 0-11.204 2.304-14.79 6.85l2.497 1.986c3.01-3.778 7.043-5.635 12.293-5.635 9.028 0 16.39 7.363 16.39 16.39a16.53 16.53 0 01-6.402 13.062l-.064.064c-4.674 4.162-5.698 7.299-6.851 15.879-.96 3.137-3.906 5.442-7.363 5.442-4.226 0-7.684-3.457-7.684-7.683H7.081a10.876 10.876 0 0010.885 10.885A10.876 10.876 0 0028.85 50.408c.96-6.147 2.05-8.26 5.378-11.205 4.866-3.777 7.62-9.411 7.62-15.558 0-10.757-8.772-19.593-19.593-19.593h.001zM48.572 48.039c2.69-4.034 2.881-9.22.512-14.342l-2.881 1.344c1.92 4.098 1.793 8.196-.256 11.205-1.857 2.753-5.059 4.225-8.772 4.034l-.191 3.201h.896c4.417 0 8.323-1.985 10.692-5.442z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M51.9 31.2c4.803 9.476 1.794 16.2-.383 19.4-3.266 4.61-8.708 7.3-13.638 6.723l-.385 3.202c.577.064 1.217.128 1.793.128 5.57 0 11.269-3.073 14.854-8.195 4.482-6.403 4.738-14.662.64-22.666l-2.88 1.408zM42.617 43.94c1.153-2.048 1.025-4.737-.32-6.658l-2.625 1.857c.64.96.769 2.241.192 3.202-.512.832-1.408 1.28-2.625 1.152l-.256 3.201h.64c2.177.064 3.97-.96 4.995-2.753z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var icons_Sensitivity = (Sensitivity);

;// CONCATENATED MODULE: ./src/components/tylenolautism/sideEffects/index.tsx








const sideEffectList = [
    {
        title: "Poor Eye Contact, the Child May Not Focus on Faces",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PoorEye, {})
    },
    {
        title: "Higher Interest in Objects Over People",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_HigherInterest, {})
    },
    {
        title: "Early Use of Ritual Behavior and Resistance to Change",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EarlyUse, {})
    },
    {
        title: "Rarely Respond to Their Name or Interact with Family Members",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_RarelyRespond, {})
    },
    {
        title: "Sensitivity to Sound, Light or Textures",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Sensitivity, {})
    }, 
];
function SideEffects() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: sideEffectList,
        mainTitle: "Symptoms of Autism Syndrome Disorder",
        mainDescription: "Children with autism may have many different symptoms and varying degrees of neurological impairments. Knowing the signs can help with the early diagnosis of autism spectrum disorder (ASD), which can improve the treatment and development options for the child. Some of the early symptoms of ASD in infants and toddlers may include:",
        classes: {
            mainSectionClasses: "mx-auto  flex justify-center items-start flex-col  mb-10  px-5  ",
            mainTitleClasses: "text-left font-bold md:leading-10 md:text-2xl text-xl leading-7 mb-5",
            innerSectionClasses: "flex flex-wrap  mt-10   gap-6 mb-14 ",
            oneBoxClasses: "flex  items-center  w-full md:w-96  mt-1",
            titleClasses: "text-sm md:text-lg  ml-8",
            mainDescriptionClasses: "text-left text-sm md:text-lg leading-8 ",
            iconClasses: " ",
            descriptionClasses: "hidden"
        },
        colors: {
            mainDescriptionColor: "#404040",
            mainTitleColor: "#901316",
            titleColor: "#404040"
        }
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ })

}]);